<div class="sponsorcontainer" >
    <h1 style="text-align: center;margin-top: 50px;"><b>ΧΟΡΗΓΟΙ</b></h1>
    <div style="vertical-align: auto;text-align: center;">
        <div *ngFor="let sponsor of sponsorlist" style="width:260px;height: 100%;display: inline-block;border: gray solid 2px;margin: 8px;" >
            <div class="cell" style="display: table-cell;vertical-align: middle;height:260px;padding:10px">
                <img [src]=sponsor width="100%"   />
            </div>
        </div>
    </div>

</div>